import { render, staticRenderFns } from "./flightPayment.vue?vue&type=template&id=25ea8496&scoped=true&"
import script from "./flightPayment.vue?vue&type=script&lang=ts&"
export * from "./flightPayment.vue?vue&type=script&lang=ts&"
import style0 from "./flightPayment.vue?vue&type=style&index=0&id=25ea8496&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ea8496",
  null
  
)

export default component.exports